import qs from 'qs';
import { Message } from 'element-ui';
import { isOverseas, currentSsoUrl } from './env';
import store from '../store';
import FileSaver from 'file-saver';
import { utils as XLSX_Utils, write as XLSX_Write } from 'xlsx';

const kfzCookiePrefix = 'kfz-';

export const htmlToExcel = {
  getExcel(dom, title = '默认标题') {
    let excelTitle = title;
    let wb = XLSX_Utils.table_to_book(document.querySelector(dom));
    /* 获取二进制字符串作为输出 */
    let wbout = XLSX_Write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'array',
    });
    try {
      FileSaver.saveAs(
        new Blob([wbout], { type: 'application/octet-stream' }),
        excelTitle + '.xlsx',
      );
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout);
    }
    return wbout;
  },
};
//import {repeatCertify} from '@/api/common';
//import router from '@/router';
/**
 * 处理数字显示。从右到左，每3位用逗号隔开。unit 参数用来设置添加逗号的间隔，默认3位
 * transformNumber(123456) => 123,456
 * @return { String } 处理后的字符串
 */
export const transformNumber = (number, unit = 3) => {
  let str = String(number);

  // 处理小数
  let [numStr1, numStr2] = str.split('.');

  let count = 1;
  let arr = [];

  // 从右往左遍历，每隔三位添加逗号
  for (let i = numStr1.length - 1; i >= 0; i--) {
    arr.unshift(numStr1[i]);
    if (i > 0 && count % unit === 0) {
      arr.unshift(',');
    }
    count++;
  }

  // 添加小数
  let res = numStr2 ? [arr.join(''), numStr2] : [arr.join('')];

  return res.join('.');
};

export const isInGame = window.mnw && window.mnw.getUserAuth;

/**
 * 错误提示
 * @param {String} message 提示文字内容
 * @param {Number} duration 提示显示时间
 */
let hasMessage = 0;
export const errorTip = (message = '', duration = 5000) => {
  if (!hasMessage) {
    hasMessage = 1;
    Message.error({
      message,
      duration,
      onClose() {
        hasMessage = 0;
      },
    });
  }
};

/**
 * @description 生成 开发者认证H5 的链接 + 参数
 * @param {*} referer
 * @returns {string} url
 */
export const createRegisterUrl = referer => {
  const url = process.env.VUE_APP_REGISTER_URL;
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');

  let params = {};
  if (userInfo) {
    // 有 token，表示账号登录， from 传1，否则传 2
    const from = userInfo.token ? 1 : 2;
    //    let version = '';
    //判断是否是427版本
    // if (userInfo.ver) {
    //   let ver = userInfo.ver.split('.');
    //   version =
    //     (parseInt(ver[0]) >> 16) + (parseInt(ver[1]) >> 8) + parseInt(ver[0]);
    // }
    // 使用小写 nickname，s2t, 与游戏登录态保持一致。
    const { nickName: nickname, st: s2t, time: time, ...others } = userInfo;

    params = qs.stringify({ ...others, nickname, s2t, time, from, referer });
  }

  return `${url}?${params}`;
};

// 判断是否登录
export const hasLogined = () => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  return !!userInfo.token || !!userInfo.auth;
};

//判断是否二次认证
export const isTwicePwded = () => {
  const token = sessionStorage.getItem('token2');
  // console.log('---'+token)
  if (token) return true;
  return false;
};
// 整理 登录后 返回的用户信息
export const neatedLoginUserInfo = (info = {}) => {
  const { nickname: nickName, ...others } = info; // 统一使用 nickName
  return { nickName, ...others, nickname: nickName };
};

// 将 登录态信息存入到 sessiosnStorage 和 vuex 中
export const setUserInfoInStorage = userInfo => {
  userInfo = userInfo || parseUserInfoFromURL();
  // 用 uin 来判断是否是有效数据
  if (userInfo.uin) {
    // sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    sessionStorage.setItem('loginTime', Date.now());
    store.commit('SET_USER_INFO', userInfo);
  }
  return userInfo;
};

const isArray = obj => {
  return Object.prototype.toString.call(obj).slice(8, -1) === 'Array';
};

// 处理 url 中的登录态信息
export const parseUserInfoFromURL = () => {
  const search = window.location.href.split('?').pop();
  let {
    uin,
    auth,
    time,
    s2t: st,
    headIndex,
    nickname: nickName, // 统一使用 nickName
    ...others
  } = qs.parse(search);

  if (isArray(auth)) {
    auth = auth[0];
  }
  if (isArray(st)) {
    st = st[0];
  }
  if (isArray(time)) {
    time = time[0];
  }

  let info = {};
  if (uin) {
    info = {
      uin: Number(uin),
      auth,
      time,
      st,
      nickName,
      nickname: nickName,
      avatar: getAvatarUrl(Number(headIndex)),
      ...others,
    };

    info.loginFormUrl = true;
  }
  // sessionStorage.setItem('loginFormUrl',true);
  return info;
};

// 处理 cookie 中的登录态信息
export const parseUserInfoFromCookie = () => {
  const { uin, nickname, headIndex, avatar, ...others } = parseKFZCookie(
    getCookies(),
  );

  let info = {};
  if (uin) {
    info = {
      ...others,
      uin,
      nickName: nickname,
      nickname,
      avatar: avatar || getAvatarUrl(Number(headIndex)),
    };
  }
  return info;
};
export const parseKFZCookie = cookieObj => {
  if (!cookieObj) return {};
  const kfzObj = {};

  Object.keys(cookieObj).forEach(key => {
    const value = cookieObj[key];
    if (key.startsWith(kfzCookiePrefix)) {
      kfzObj[key.replace(kfzCookiePrefix, '')] = value;
    }
  });
  return kfzObj;
};
// 获取所有 cookie
export const getCookies = () => {
  const { cookie } = document;
  const info = {};
  cookie.split(';').forEach(item => {
    const [key, value] = item.split('=');
    info[key.trim()] = value && decodeURIComponent(decodeURIComponent(value));
  });

  return info;
};

// 获取具体的 cookie
export const getCookie = key => {
  const cookies = getCookies();
  return cookies[key];
};

export const clearLoginInfoFromCookie = () => {
  [
    'uin',
    'sid',
    'token',
    'tk',
    'st',
    'sso_token',
    'avatar',
    'nickname',
  ].forEach(key => deleteCookie(`${kfzCookiePrefix}key`));
};

export function deleteCookie(name) {
  document.cookie =
    name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mini1.cn';
}

// 跳转到 sso
export const navToSSO = () => {
  if (currentSsoUrl) {
    console.log(currentSsoUrl);
    window.location.href =
      currentSsoUrl + `/#/?url=${encodeURIComponent(window.location.href)}`;
  }
};

// 转换海外版迷你号。isAdd 代表 加 还是 减 10亿
export const transformOverseasUin = (uin, isAdd = true) => {
  let res = Number(uin);
  let m = 1000000000;
  if (isAdd) {
    res += m;
  } else {
    res -= m;
  }
  return res;
};

/**
 * 计算用户头像URL
 * @param {Number|Object} headInfo
 * 说明：
 * 1、游戏登录态参数，取登录态中的headIndex
 * 2、密码登录取得的baseinfo，取baseinfo.RoleInfo
 * 3、验证码登录，取返回值中的Model和SkinID参数，组装成字面量对象
 */
export const getAvatarUrl = headInfo => {
  // 如果是从游戏内带的登录态，则直接使用带出来的id，因为游戏内已经算好id
  if (typeof headInfo === 'number') {
    return `https://image.mini1.cn/roleicon/${headInfo}.png`;
  } else if (headInfo !== null && typeof headInfo === 'object') {
    // 皮肤ID映射
    const skinHeadIdMap = {
      10: 39,
      9: 38,
      8: 37,
      6: 35,
      7: 36,
      5: 34,
      4: 33,
      3: 30,
      2: 32,
      1: 31,
    };

    let resultID = 0;
    let skinID = +headInfo.SkinID;

    if (skinID <= 0) {
      // 没有皮肤使用Model
      resultID = +headInfo.Model;
    } else {
      // 有皮肤且存在于映射表中使用映射表中的id
      if (skinHeadIdMap[skinID]) {
        resultID = skinHeadIdMap[skinID];
      } else {
        // 不存在则使用skinid + 29
        resultID = skinID + 29;
      }
    }
    return `https://image.mini1.cn/roleicon/${resultID}.png`;
  } else {
    return 'https://image.mini1.cn/roleicon/1.png';
  }
};

/* 打点接口 */
export const reportLog = (options = {}) => {
  const url = process.env.VUE_APP_ENV.includes('prod')
    ? isOverseas
      ? 'https://tjhk.mini1.cn' // 海外
      : 'https://tj2.mini1.cn' // 国内
    : 'http://120.24.64.132:8080';

  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  const { uin = '', apiid = '', ver = '' } = userInfo;
  const opt = {
    ...options,
    v1: uin,
    v2: apiid,
    v3: ver,
    v4: '',
    v5: '',
  };

  let logImg = new Image();
  logImg.onload = logImg.onerror = function () {
    logImg = null;
  };

  // 格式化数据
  let str = '';
  for (let key in opt) {
    if (Object.prototype.hasOwnProperty.call(opt, key)) {
      let element = opt[key];
      str += '&' + key + '=' + element;
    }
  }

  let logParams = str.substring(1);

  logImg.src = url + '/miniworld?' + logParams;
};
let renameTimer = null;
export const renameLoginTitle = name => {
  if (!name) return;
  document.head.querySelector('title').innerText = name;
  renameTimer = setInterval(() => {
    const $loginTitle = document.querySelector('.login_title_word');
    if ($loginTitle) {
      clearInterval(renameTimer);
      $loginTitle.innerText = name;
    }
  }, 200);
};
// 格式化起始时间到当天  00:00:00
export const formatStartTime = time => {
  console.log('formatStartTime', time);
  if (!time) return formatStartTime(new Date());
  if (Object.prototype.toString.call(time).slice(8, -1) === 'Date') {
    // time = new Date();
    let t = new Date(
      time.getFullYear() +
        '/' +
        (time.getMonth() + 101 + '').slice(-2) +
        '/' +
        (time.getDate() + 100 + '').slice(-2) +
        ' 00:00:00',
    ).getTime();
    return Math.round(t / 1000);
  } else {
    return formatStartTime(new Date(time));
  }
};
// 格式化终止时间到当天  23:59:59
export const formatEndTime = time => {
  if (!time) return formatEndTime(new Date());
  if (Object.prototype.toString.call(time).slice(8, -1) === 'Date') {
    // time = new Date();
    let t = new Date(
      time.getFullYear() +
        '/' +
        (time.getMonth() + 101 + '').slice(-2) +
        '/' +
        (time.getDate() + 100 + '').slice(-2) +
        ' 23:59:59',
    ).getTime();
    return Math.round(t / 1000);
  } else {
    return formatEndTime(new Date(time));
  }
};

export function formatDate(dateVal) {
  // 时间戳转 yy-mm-dd hh:mm:ss
  const date = new Date(dateVal);
  const YY = date.getFullYear() + '-';
  const MM =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-';
  const DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  const hh =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  const mm =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':';
  const ss =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return YY + MM + DD + ' ' + hh + mm + ss;
}

export function dateFormat(date = new Date(), fmt = 'YYYY-MM-DD HH:mm:ss') {
  date = new Date(date);
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(),
    'M+': (date.getMonth() + 1).toString(),
    'D+': date.getDate().toString(),
    'H+': date.getHours().toString(),
    'm+': date.getMinutes().toString(),
    's+': date.getSeconds().toString(),
  };
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        (ret[1].length === 1)
          ? (opt[k])
          : (opt[k].padStart(ret[1].length, '0'))
      );
    }
  }
  return fmt;
}

export function downloadFile(url) {
  let a = document.createElement('a');
  a.href = url;
  a.download = url.split('/').pop();
  a.click();
}
